import s from './students-list-modal.module.scss'
import { Modal } from '@shared/ui/modal/modal';
import { StudentsList } from '@widgets/teacher/ui/students-list/students-list';
import { useTeacherStudentsListModal } from '../model/use-teacher-students-list-modal';

export const StudentsListModal = () => {
	const { isOpen, close } = useTeacherStudentsListModal();

	return (
		<Modal isOpen={isOpen} close={close} title="Мои ученики" style={{content:{maxWidth: 420}}}>
			<div className={s.wrapper}>
				<StudentsList compact />
			</div>
		</Modal>
	);
};
